/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanySendInvitationRequest
 */
export interface ClientCompanySendInvitationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCompanySendInvitationRequest
     */
    emails: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanySendInvitationRequest
     */
    clientCompanyId: string;
}

/**
 * Check if a given object implements the ClientCompanySendInvitationRequest interface.
 */
export function instanceOfClientCompanySendInvitationRequest(value: object): value is ClientCompanySendInvitationRequest {
    if (!('emails' in value) || value['emails'] === undefined) return false;
    if (!('clientCompanyId' in value) || value['clientCompanyId'] === undefined) return false;
    return true;
}

export function ClientCompanySendInvitationRequestFromJSON(json: any): ClientCompanySendInvitationRequest {
    return ClientCompanySendInvitationRequestFromJSONTyped(json, false);
}

export function ClientCompanySendInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanySendInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': json['emails'],
        'clientCompanyId': json['clientCompanyId'],
    };
}

export function ClientCompanySendInvitationRequestToJSON(value?: ClientCompanySendInvitationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'emails': value['emails'],
        'clientCompanyId': value['clientCompanyId'],
    };
}

